<template>
    <div class="session-list-container">
        <div class="session-list-header">
            <h3>Чаты</h3>
            <image-button :src="PlusIcon" :hint="'Новый чат'" @click="createNewSession" />
        </div>
        <div class="session-list">
            <div v-if="sessions.numberOfElements === 0" class="empty-sessions">
                Нет активных чатов
            </div>
            <div v-for="session in sessions.content" :key="session.id" class="session-item"
                @click="selectSession(session.id)">
                <div class="session-title" :class="{ selected: sessionId == session.id }">{{ session.name || 'Новый чат' }}</div>
                <div class="session-date">{{ formatDate(session.createdAt) }}</div>
                <image-button class="delete-btn" :src="TrashIcon" size="18" red :hint="'Удалить чат'"
                    @click.stop="deleteSession(session.id)" />
            </div>
            <span v-if="sessions.number < sessions.totalPages - 1" @click="nexPage" class="next-page">
                Показать еще
            </span>
        </div>
    </div>
</template>

<script setup>
import { onMounted, defineEmits } from 'vue';
import { storeToRefs } from 'pinia';
import { useAgentStore } from '@/store/AgentStore';
import PlusIcon from '@/assets/icons/Add_Plus.svg';
import TrashIcon from '@/assets/icons/Trash_Full.svg';

const emit = defineEmits(['sessionCreated']);

const agentStore = useAgentStore();
const { sessions } = storeToRefs(agentStore);
const { sessionId } = storeToRefs(agentStore);

const createNewSession = async () => {
     const session = await agentStore.createSession();
     console.log('created session', session);
     emit('sessionCreated', sessionId);
};

const selectSession = async (id) => {
    await agentStore.selectSession(id);
};

const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

const nexPage = async () => {
    console.log('fetch next page', sessions.value.number, sessions.value.totalPages);
    if (sessions.value.number < sessions.value.totalPages - 1) {
        await agentStore.fetchSessions(sessions.value.number + 1);
    }
}

onMounted(() => {
    agentStore.fetchSessions();
});

const deleteSession = (id) => {
    agentStore.deleteSession(id);
};
</script>

<style lang="scss" scoped>
.session-list-container {
    display: flex;
    flex-direction: column;
    height: 100%;

    .next-page {
        text-align: center;
        color: var(--color-primary);
        cursor: pointer;
        margin-top: 10px;

        &:hover {
            text-decoration: underline;
        }
    }

    .delete-btn {
        display: none;
    }
}

.session-list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
    //border-bottom: 1px solid var(--color-border);

    h3 {
        margin: 0;
        font-size: 16px;
        color: var(--color-text);
    }
}

.session-list {
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.session-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 15px 5px 0px;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        .session-title {
            text-decoration: underline;
        }

        .delete-btn {
            display: block;
        }

        .session-date {
            display: none;
        }
    }
}

.session-title {
    font-weight: 500;
    color: var(--color-text);
    margin: 1px 0;

    &.selected {
        color: var(--color-blue);
    }
}

.session-date {
    font-size: 12px;
    color: var(--color-text-light);
}

.empty-sessions {
    text-align: center;
    color: var(--color-text-light);
    margin-top: 20px;
}
</style>
